






















import { Component, Vue } from "vue-property-decorator";
import TitleHeader from "@/components/header.vue";
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
@Component({
  components: {
    TitleHeader,
  },
})
export default class Home extends Vue {
  public data = [
    { id: "1", name: "qq客服" },
    { id: "2", name: "qq群客服" },
    { id: "3", name: "微信客服" },
    { id: "4", name: "微信公众号" },
    { id: "5", name: "电话" },
  ];
  public getService(id) {
    for (let i = this.data.length - 1; i >= 0; i--) {
      if (this.data[i].id === id) {
        return this.data[i].name;
      }
    }
  }
  public onCopy() {
    return this.$toast("复制成功");
  }
  public onError() {
    return this.$toast("复制失败，请重试");
  }
}
